module.exports = __webpack_public_path__ + "img/cases-brand-chinamobile-17.160573e9.jpg";